<button mat-stroked-button type="button" class="drp-trigger" [matMenuTriggerFor]="menu"
        (click)="beginEdit()">
  <mat-icon>calendar_today</mat-icon>
  <span>
    @if (appliedPresetLabel) {
      {{ appliedPresetLabel | translate }}
    } @else {
      {{ appliedRangeText || ('App.Picker.SelectRange' | translate) }}
    }
  </span>
  <mat-icon class="drp-chev">arrow_drop_down</mat-icon>
</button>

<mat-menu #menu="matMenu" class="drp-menu" xPosition="before">
  <!-- stopPropagation keeps clicks inside the panel from closing the menu -->
  <div class="drp-panel" (click)="$event.stopPropagation()">
    <div class="drp-presets">
      <button type="button" class="drp-preset" *ngFor="let p of presets"
              [class.drp-on]="activePreset === p.key" (click)="applyPreset(p)">
        {{ p.label | translate }}
      </button>
    </div>

    <div class="drp-cal">
      <mat-calendar [selected]="selected" [startAt]="startAt" [maxDate]="maxDate"
                    (selectedChange)="onCalendarSelect($event)"></mat-calendar>
      <div class="drp-foot">
        <span class="drp-range">{{ rangeText || ('App.Picker.PickRange' | translate) }}</span>
        <div class="drp-foot-actions">
          <button type="button" class="drp-clear" (click)="clear()">{{ 'App.Picker.Clear' | translate }}</button>
          <button mat-flat-button color="primary" class="drp-apply" type="button"
                  [disabled]="!selected.start || !selected.end" (click)="apply()">
            {{ 'App.Picker.Apply' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-menu>
